import { CRM_CONFIG } from '@/config/constants';
import { generatePdfFilename } from '@/utils/formatters';

export class PdfStorageService {
  private static instance: PdfStorageService;

  private constructor() {}

  static getInstance(): PdfStorageService {
    if (!PdfStorageService.instance) {
      PdfStorageService.instance = new PdfStorageService();
    }
    return PdfStorageService.instance;
  }

  async uploadPdfToCrm(blob: Blob, leadId: number): Promise<void> {
    const filename = generatePdfFilename(leadId);

    const formData = new FormData();
    formData.append('file', blob, filename);

    const url = `${CRM_CONFIG.BASE_URL_WRITE}/OportunidadeAnexo/Upload/${leadId}`;

    console.log(`[PDF Upload] POST ${url}`);
    console.log(`[PDF Upload] Filename: ${filename}, Size: ${blob.size} bytes`);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Token': CRM_CONFIG.TOKEN
        },
        body: formData
      });

      const responseText = await response.text();
      console.log(`[PDF Upload] Response status: ${response.status} ${response.statusText}`);
      console.log(`[PDF Upload] Response body: ${responseText || '(empty)'}`);

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status} ${response.statusText} - ${responseText}`);
      }

      console.log('[PDF Upload] Upload successful!');
    } catch (error) {
      console.error('[PDF Upload] Error:', error);
      throw error;
    }
  }
}

export const pdfStorageService = PdfStorageService.getInstance();
